module.exports = __webpack_public_path__ + "img/solucion-servidores.90d5a844.png";